import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyChipLoading } from 'routes/HumanResourcesModule/components/ui/StyChipLoading';
import StyIconChip from 'routes/HumanResourcesModule/components/ui/StyIconChip';
import { AgentDepartureHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Departure/helpers/types';
import { AgentPayComponentHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/PayComponent/helpers/types';
import { usePrimaryColor } from 'styles/theme';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import StyChip from 'routes/HumanResourcesModule/components/ui/StyChip';
import EditIcon from '@mui/icons-material/Edit';
import { MANTY_COLORS } from 'business/constants';
import { GradeAdvancementHypothesis } from '../../GradeAdvancement/helpers/types';

type Props = {
    isLoading: boolean;
    hypotheses: (
        | AgentDepartureHypothesis
        | GradeAdvancementHypothesis
        | AgentPayComponentHypothesis
    )[];
    setShowModal: (show: boolean) => void;
    isDisabled: boolean;
};

const AddContent = ({
    isLoading,
    hypotheses,
    setShowModal,
    isDisabled,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const primaryColor: string = usePrimaryColor();

    if (isLoading) {
        return <StyChipLoading />;
    }
    if (hypotheses.length === 0) {
        return (
            <StyChip
                label={
                    isDisabled
                        ? t('humanResources.obsoleteService')
                        : t('humanResources.simulation.addHypothesis')
                }
                onClick={() => {
                    if (!isDisabled) {
                        setShowModal(true);
                    }
                }}
                icon={isDisabled ? <></> : <AddCircleOutlinedIcon />}
                styledColor={isDisabled ? MANTY_COLORS.darkGrey : primaryColor}
            />
        );
    }
    return (
        <>
            {!isDisabled && (
                <StyIconChip
                    onClick={() => setShowModal(true)}
                    icon={<EditIcon />}
                    styledColor={
                        isDisabled ? MANTY_COLORS.darkGrey : MANTY_COLORS.orange
                    }
                    disabled={isDisabled}
                />
            )}
        </>
    );
};

export default AddContent;
